import { useTranslation } from 'react-i18next';
import { Building2, Coins, KeyRound, Wallet } from 'lucide-react';
import { money } from './assetUtils';

export const AssetSummary = ({ summary }) => {
  const { t, i18n } = useTranslation();
  const totals = field => summary?.currencies.length ? summary.currencies.map(row =>
    <div key={row.currency} data-testid={`assets-${field.replaceAll('_', '-')}-${row.currency}`}>{money(row[field], row.currency, i18n.language)}</div>) : '—';
  const stats = [
    { id: 'total', label: 'totalAssets', value: summary?.total ?? '—', icon: Building2, color: 'text-blue-600' },
    { id: 'value', label: 'totalValue', value: totals('estimated_value'), icon: Wallet, color: 'text-emerald-600' },
    { id: 'rented', label: 'rentedAssets', value: summary?.rented ?? '—', icon: KeyRound, color: 'text-indigo-600' },
    { id: 'rent', label: 'monthlyRent', value: totals('monthly_rent'), icon: Coins, color: 'text-amber-600' },
  ];
  return <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="assets-summary">
    {stats.map(({ id, label, value, icon: Icon, color }) => <div key={id} className="bg-white border border-slate-200 rounded-sm p-5 min-w-0">
      <div className="flex items-center justify-between gap-3"><span className="text-xs font-semibold uppercase text-slate-500">{t(`assets.${label}`)}</span><Icon className={`w-4 h-4 shrink-0 ${color}`} /></div>
      <div className="mt-3 text-xl font-display font-semibold text-slate-900 break-words" data-testid={`assets-summary-${id}`}>{value}</div>
    </div>)}
  </div>;
};